import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import state from './state'
import user from './modules/user'
import profile from './modules/profile'
import goods from './modules/goods'
import order from './modules/order'
Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    user,
    profile,
    order,
    goods
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js